"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["className", "size", "lazy", "altText", "borderRadius", "src"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box } from '@autoguru/overdrive';
import { LazyPicture, Picture } from '@autoguru/picture';
import * as styles from './Avatar.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const Avatar = _ref => {
  let {
      className,
      size = 40,
      lazy = true,
      altText = 'avatar image',
      borderRadius = 'full',
      src
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const pictureProps = _objectSpread({
    src: src,
    width: size,
    height: size,
    aspectRatio: 1,
    objectFit: 'cover',
    altText
  }, rest);
  return /*#__PURE__*/_jsx(Box, {
    borderRadius: borderRadius,
    overflow: "hidden",
    flexShrink: 0,
    className: [className, styles.root],
    style: {
      width: size,
      height: size
    },
    children: lazy ? /*#__PURE__*/_jsx(LazyPicture, _objectSpread({}, pictureProps)) : /*#__PURE__*/_jsx(Picture, _objectSpread({}, pictureProps))
  });
};